module.exports = __webpack_public_path__ + "img/flagArrowsCountry.20f4da64.svg";